/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LootBoxConfigResponse } from './LootBoxConfigResponse';
import {
    LootBoxConfigResponseFromJSON,
    LootBoxConfigResponseFromJSONTyped,
    LootBoxConfigResponseToJSON,
    LootBoxConfigResponseToJSONTyped,
} from './LootBoxConfigResponse';

/**
 * 
 * @export
 * @interface DeleteLootBoxPrizeResponse
 */
export interface DeleteLootBoxPrizeResponse {
    /**
     * 
     * @type {LootBoxConfigResponse}
     * @memberof DeleteLootBoxPrizeResponse
     */
    lootBoxConfig: LootBoxConfigResponse;
}

/**
 * Check if a given object implements the DeleteLootBoxPrizeResponse interface.
 */
export function instanceOfDeleteLootBoxPrizeResponse(value: object): value is DeleteLootBoxPrizeResponse {
    if (!('lootBoxConfig' in value) || value['lootBoxConfig'] === undefined) return false;
    return true;
}

export function DeleteLootBoxPrizeResponseFromJSON(json: any): DeleteLootBoxPrizeResponse {
    return DeleteLootBoxPrizeResponseFromJSONTyped(json, false);
}

export function DeleteLootBoxPrizeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteLootBoxPrizeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'lootBoxConfig': LootBoxConfigResponseFromJSON(json['lootBoxConfig']),
    };
}

export function DeleteLootBoxPrizeResponseToJSON(json: any): DeleteLootBoxPrizeResponse {
    return DeleteLootBoxPrizeResponseToJSONTyped(json, false);
}

export function DeleteLootBoxPrizeResponseToJSONTyped(value?: DeleteLootBoxPrizeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lootBoxConfig': LootBoxConfigResponseToJSON(value['lootBoxConfig']),
    };
}

